import React from 'react';

import SettingsContainer from './SettingsContainer';
import { SettingsDetail } from './SettingsDetail';

const SettingsPage: React.FC = () => (
    <SettingsContainer.Provider>
        <SettingsDetail/>
    </SettingsContainer.Provider>
);
export default SettingsPage;
